export class Agente {
    idagente: string = "";
    nombre: string = "";
    pass?: string = "";
    penalidad: number = 0;
    canPause = false;
    canHangup = false;
    canXFER = true;
    modoAgente: EModoAgente;
    logged_on: string;
    estado_fecha: Date;
    estado_idreason: string;
    last_call: string;
    last_call_date: Date;
    // 
    stats?: IStats[];
    
    constructor(){}
}

export interface IStats {
    cola: string;
    completeUsuario: number;
    completeAgente: number;
    completeTiempo: number;
}

export interface IAgentStatusReason {
    idreason: string;
    tipo: string;
    motivo: string;
    autor: string,
    fecha?: any
}

export enum EModoAgente {
    NONE, RINGBACK, AUTOMATIC, OUTBOUND
}

export enum EModalidadAgente {
    RINGBACK, AUTOMATIC, OUTBOUND
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/angular2-router-loader/src!./common/agente.ts